<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 




<div id="myModalStudentAddGroup" class="modal">
<div class="modal-background" @click="students_add_hide()"></div>
<div class="modal-content" style="width: 50%;height:85%;"> 
<div  class="box has-background-white">
<!-- CLOSE BUTTON  -->
<div class="columns is-gapless" style="margin-bottom:-1em;">
<div @click="students_add_hide()" class="column is-12 has-text-right has-text-danger isLink">X CLOSE</div>
</div>
<!-- ADD STUDENTS!! -->
<div class="columns is-centered is-gapless is-multiline mb-6">
<div class="column is-5 is-size-3 has-text-weight-bold has-background-success-light"> ADD STUDENTS ! </div>

<div class="column is-3 is-size-3 has-text-weight-bold has-background-success-light has-text-centered">{{arr_studs_add.length}}</div>

<div class="column is-8">
<div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
    <div class="column is-6">
        <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="students_search()" class="input is-size-6 has-text-weight-bold is-fullwidth" type="text" placeholder="search">
        <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div>

    <div class="column is-paddingless has-text-centered is-size-4 has-text-weight-bold is-1 has-tooltip-left has-tooltip-warning" data-tooltip="Search Students"><button @click="students_search()" class="button is-fullwidth has-background-success has-text-white"><span class="icon is-medium"><i class="fas fa-search"></i></span></button></div>

    <div class="column is-paddingless has-text-centered is-size-4 has-text-weight-bold is-1 has-tooltip-left has-tooltip-warning" data-tooltip="Clear Search"><button @click="students_search_clear()" class="button is-fullwidth has-background-grey-dark has-text-warning"><span class="icon is-medium"><i class="fas fa-minus-circle"></i></span></button></div>
    <div class="column is-1"></div>
    <div class="column is-paddingless has-text-centered is-size-4 has-text-weight-bold is-3 has-tooltip-left has-tooltip-warning" data-tooltip="Save Students"><button @click="students_add_save()" class="button is-fullwidth has-background-success has-text-white"><span class="icon is-medium"><i class="fas fa-save"></i></span></button></div>
</div>
<!-- END SEARCH BUTTONS BOX  -->
</div>
<!-- <div class="columns">      "check_inscrit(stud.student_ID)" -->
<div class="column is-8" v-for ="(stud, ind) in student_add" :key="stud.student_ID">
<div v-if="!check_inscrit(stud.student_ID)" class="colBorder" style="padding:6px;"> 
<CompStudentBox :data="stud"  
    enabled='true'
    :key="stud.student_ID"
    btnType="ADD"
    @emit_click_add="emit_click_add"
    @emit_click_add_undo="emit_click_add_undo"
    > </CompStudentBox>
</div>
</div>
</div><!-- END ADD STUDENTS -->
</div></div></div>
<!-- END MODAL ADD STUDENT TO GROUP !  -->


<!-- **** REMOVE STUDENT MODAL !! ****  -->
<div id="myModalStudentRemoveGroup" class="modal">
<div class="modal-background" @click="students_remove_show()"></div>
<div class="modal-content" style="width: 50%;height:85%;"> 
<div  class="box has-background-white">
<!-- CLOSE BUTTON  -->
<div class="columns is-gapless" style="margin-bottom:-1em;">
<div @click="students_remove_hide()" class="column is-12 has-text-right has-text-danger isLink">X CLOSE</div>
</div>
<!-- ADD STUDENTS!! -->
<div class="columns is-centered is-gapless is-multiline mb-6">
<div class="column is-8 is-size-3 has-text-weight-bold has-background-danger-light"> REMOVE STUDENTS ! </div>
<div class="column is-8">
<div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
     <div class="column is-paddingless has-text-centered is-size-4 has-text-weight-bold is-12"><button @click="students_remove_save()" class="button is-fullwidth has-background-grey-dark has-text-success"><span class="icon is-medium"><i class="fas fa-save"></i></span></button></div>
</div>
<!-- END SEARCH BUTTONS BOX  -->
</div>
<!-- <div class="columns"> -->
<div class="column is-8">
<div class="colBorder" style="padding:6px;" v-for ="(stud, ind) in data_student" :key="stud.student_ID"> 
<CompStudentBox :disabled="!is_changed"
    :data="stud"
    :key="stud.student_ID"
    btnType="REMOVE"
    @emit_click_remove="emit_click_remove"
    @emit_click_remove_undo="emit_click_remove_undo"
    > </CompStudentBox>
</div>
</div>
</div><!-- END ADD STUDENTS -->
</div></div></div>
<!-- END MODAL REMOVE STUDENT FROM GROUP !  -->



<!-- **** PONDERATION MODAL !! ****  -->
<div id="myModalPonderation" class="modal">
<div class="modal-background" @click="ponderation_show()"></div>
<div class="modal-content" style="width: 50%;height:85%;"> 
<div  class="box has-background-white">
<!-- CLOSE BUTTON  -->
<div class="columns is-gapless" style="">
<div @click="ponderation_hide()" class="column is-12 has-text-right has-text-danger isLink">PONDERATION : X CLOSE</div>
</div>
<div class="columns is-centered is-gapless is-multiline">

<div class="column mt-3 is-4 is-size-7 has-text-weight-bold"> Desc </div>
<div class="column is-size-7 has-text-weight-bold is-1">
    <button class="button is-fullwidth is-small  has-background-light has-text-success"  @click="ponderation_click_new()">
        <span class="icon is-medium"><i class="fas fa-plus"></i></span>
    </button>
</div>
<div class="column is-3 mt-3 is-size-7 has-text-weight-bold">&nbsp; Max </div>
<div class="column is-1 mt-3 is-size-7 has-text-weight-bold"> Percent </div>

     <div class="column is-paddingless has-text-centered is-size-7 has-text-weight-bold is-3"><button @click="ponderation_save_modal()" class="button is-fullwidth is-small has-background-success has-text-white"><span class="icon is-medium"><i class="fas fa-save"></i></span></button></div>





<div class="column is-12">
<div v-for ="(info, index) in data_ponderation" :key="index" class="columns is-multiline is-gapless" style="margin-bottom:0em;">

    <div class="column is-5">
            <input v-model="info.ponderation_Desc"  v-on:keyup="is_changed=true" class="input is-fullwidth" type="text" placeholder="description">
    </div>
    <div class="column is-3">
            <input v-model="info.ponderation_Max"  v-on:keyup="is_changed=true" class="input is-fullwidth" type="number" placeholder="description">
    </div>
    <div class="column is-3">
            <input v-model="info.ponderation_Percent"  v-on:keyup="is_changed=true" class="input is-fullwidth" type="number" placeholder="description">
    </div>

  <div  @keyup.tab="ponderation_click_new()" class="column has-text-right is-1 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
    <button @click="pond_delete_confirm(index)" class="button is-fullwidth has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-trash-alt"></i> </span></button>
  </div> 


</div></div>
<!-- NEW DEV  --> 


</div><!-- END ADD STUDENTS -->
</div></div></div>
<!-- END MODAL PONDERATION !  -->
  



 
<div class="columns is-multiline is-gapless is-mobile" style="margin-top:-.8em;margin-left:-.7em;">

<div class="column is-12" >
<div class="columns is-multiline is-vcentered has-background-grey-lighter pt-3 pb-3">
<div @click="students_add_show()" v-if="chkAdminView() == true" class="column pl-6 button is-2 is-size-6 has-text-weight-bold has-text-left has-background-success-light"><span class="icon is-small"><i class="fas fa-user-plus"></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;ADD STUDENTS</div>
<div @click="students_remove_show()" v-if="chkAdminView() == true" class="column button is-2 is-size-6 has-text-weight-bold has-text-right has-background-danger-light"><span class="icon is-small"><i class="fas fa-user-times"></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;REMOVE</div>

<div class="column is-1"></div><!-- SPACER COLUMN !  -->


<div @click="is_changed=!is_changed" class="column pl-6 button is-3 is-size-6 has-text-weight-bold has-text-left ">
    <span class="icon is-small"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
    DETAILS
    <span class="icon is-small is-pulled-right mr-2"><i class="fas fa-edit"></i></span>
    </div>
<div class="column is-1"></div><!-- SPACER COLUMN !  -->
<div @click="ponderation_show()" class="column pl-6 button is-3 is-size-6 has-text-weight-bold has-text-left"><span class="icon is-small"><i class="fas fa-list-ol"></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
PONDERATION
<span class="icon is-small is-pulled-right mr-2"><i class="fas fa-edit"></i></span>
</div>

</div>
</div>




<!-- COLUMN STUDENTS -->
<div class="column is-4" :class="chkAdminMod()">
<div class="colBorder" style="padding:6px;" v-for ="(stud, ind) in data_student" :key="randomKey(ind)"> 


<div class="columns is-mobile is-gapless is-vcentered has-background-white" style="margin-bottom:0em;">
<div class="column is-2">          
<figure class="image is-32x32">
    <img :src="return_pic(stud.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
</figure>       
</div>
<div class="column is-10">         
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold" style="">{{stud.student_lNAME}}</div>
        <div class="column is-8 is-size-7" style="margin-top:-.5em;"> {{stud.student_fNAME}}</div>
        <div class="column is-4 is-size-7 has-text-info has-text-right has-text-weight-bold" style="margin-top:-.5em;">{{stud.student_GRPCODE}}&nbsp;&nbsp;</div>
    </div>
</div>
</div>

</div>
</div><!-- END COLUMN STUDENTS -->






<div class="column is-1"></div>
<!-- SPACER COLUMN !  -->



<div class="column is-3" :class="chkAdminMod()">

<div class="box has-background-grey-lighter"> 
<div class="columns is-multiline is-gapless">
<div class="column is-8">
    <span class="isLabel"> Groupe/Course code</span>
        <div class="control">
<input :disabled="!is_changed" v-model="det_code"  v-on:keyup="is_changed=true" class="input is-fullwidth" type="text" placeholder="code">
        </div>
</div>
<div class="column is-4">
        <span class="isLabel"> Language </span>
        <div class="control">
        <div class="select is-fullwidth">
            <select :disabled="!is_changed" @change="is_changed=true" v-model="det_lang">
    <option value="NULL"></option>
    <option value="F">F</option>
    <option value="E">E</option>
            </select>
        </div>
        </div>
</div>  

 <div class="column is-6">
    <span class="isLabel"> Start Date </span>
    <p class="control has-icons-left">
        <flat-pickr :disabled="!is_changed"
            v-model="det_start"
            @input="is_changed=true"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div>
<div class="column is-6">
    <span class="isLabel"> End Date </span><span class="is-pulled-right"> {{det_sessann}} </span>
    <p class="control has-icons-left">
         <flat-pickr :disabled="!is_changed"
            v-model="det_end"
            @input="is_changed=true"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtEnd">
        </flat-pickr> 
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
</div>  


<div class="column is-12">
    <span class="isLabel"> Prof 1 </span>
        <div class="control">
        <div class="select is-fullwidth">
            <select :disabled="!is_changed" @change="is_changed=true" v-model="det_prof1">
    <option value="NULL"></option>
    <option v-for="(prof,index) in prof_data" :value="prof.staff_ID"  :key="index" >{{ prof.prof }}</option>
            </select>
        </div>
        </div>
        <span class="isLabel"> Prof 2 </span>
        <div class="control">
        <div class="select is-fullwidth">
            <select :disabled="!is_changed" @change="is_changed=true" v-model="det_prof2">
    <option value="NULL"></option>
    <option v-for="(prof,index) in prof_data" :value="prof.staff_ID"  :key="index" >{{ prof.prof }}</option>
            </select>
        </div>
        </div>
</div>  
 
<div class="column is-12">
<div class="columns is-multiline is-gapless" style="margin-top:1em;">

   <div class="column is-12 mb-3">
<button :disabled="!is_changed" class="button is-fullwidth has-background-success has-text-white" @click="group_save()"><span class="icon is-small"><i class="fas fa-save"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;SAVE COURSE</button>
   </div> 

   <div class="column is-12">
<button :disabled="!is_changed" class="button is-fullwidth has-background-danger has-text-white" @click="group_delete_confirm()"><span class="icon is-small"><i class="fas fa-trash-alt"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;DELETE COURSE</button>
   </div> 

   <!-- <div v-if="show_confirm_grp" class="column is-4">
<a class="button is-fullwidth has-background-white has-text-danger" @click="show_confirm_grp=false"><span class="icon is-small"><i class="fas fa-window-close"></i></span>&nbsp;&nbsp;CANCEL</a>
   </div>
   <div v-if="show_confirm_grp" class="column is-8">
<a class="button is-fullwidth has-background-primary has-text-black" @click="group_delete()"><span class="icon is-small"><i class="fas fa-trash-alt"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;DELETE CONFIRM</a>
   </div> -->


</div>   
</div>


</div>
</div><!-- END GROUP DETAILS!!!! (DATES/PROF ...) -->
</div><!-- COLUMN end -->
<!-- </div></div>  -->
<!-- END MODAL CHANGE COURSE INFO  -->


<div class="column is-1"></div>
<!-- SPACER COLUMN !  -->



<!-- PONDERATION  -->
<div class="column is-3" >
<div class="box has-background-grey-lighter " style="margin-bottom:0em;">
<div class="columns is-multiline has-text-weight-bold"  v-for ="(info, index) in data_ponderation" :key="randomKey(index)">
<div class="column is-8 colBorder colNotes has-background-white">{{info.ponderation_Desc}} </div>
<div class="column is-2 colBorder has-background-white">{{info.ponderation_Max}} </div>
<div class="column is-2 colBorder has-background-white">{{info.ponderation_Percent}}% </div>
</div>
</div><!-- END PONDERATION -->
</div><!-- COLUMN -->



</div><!--MAIN COLUMN -->


</div>
</template>



<script>
import axios from 'axios';
import moment from 'moment';

import CompStudentBox  from '@/components/Comp_Student_Box';

export default {
        // props: ['student_data','student_copy', 'data_ponderation', 'group_data', 'prof_data'  ],
        props: [ 'group_id' , 'prof_data' ],
        components: { CompStudentBox },

        data() {
            return {
isLoading:false,
is_changed:false,
student_add:[],

data_student:[],
data_ponderation:[],

arr_studs_add:[], // HOLDS ADDING STUDENTS TO GROUP
arr_studs_remove:[], // HOLDS REMOVE STUDENTS


search:'',
config: { // FLATPICKER
    altFormat: "M j, y",
    altInput: true
},

show_confirm_grp:false,
show_pond:false,
pond_id:'',
pond_desc:'',
pond_max:'',
pond_percentage:'',
pond_index:'',
pond_order:'',
show_confirm_pond:false,

/* grp_dtStart:this.group_data.group_datSTART
,grp_dtEnd:this.group_data.group_datEND,
grp_prof1:this.group_data.prof1_ID,
grp_prof2:this.group_data.prof2_ID, */

det_code:'',
det_sessann:'',
det_lang:'',
det_start:'',
det_end:'',
det_prof1:'',
det_prof2:'',

grp_profs:'',
                 students:'',
                 
            }
        },



created() {

this.isLoading=true;
// GET GROUP DETAILS
var sql = ` SELECT * FROM  MyMEQ_GROUP  WHERE MyMEQ_GROUP.group_ID = ` + this.group_id 
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { 

    this.det_code = res.data[0].group_CODE
    this.det_sessann = res.data[0].group_SESS + "-" + res.data[0].group_ANN 
    this.det_lang = res.data[0].group_LANG
    this.det_start = res.data[0].group_datSTART
    this.det_end = res.data[0].group_datEND
    this.det_prof1 = res.data[0].staff_ID_1
    this.det_prof2 = res.data[0].staff_ID_2

// GET GROUP STUDENTS
var sql = ` SELECT MyMEQ_STUDENT.* FROM  MyMEQ_STUDENT INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID WHERE MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + ` ORDER BY student_lNAME `
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { 
        this.data_student = res.data



this.get_ponderations()
this.isLoading=false;
    })

})

},
// END CREATED

watch: {

    // is_changed: function() {

    // },

    det_end: function() {
    // GET SESSION ANNEE
    var sessann = moment(this.det_end).format('M')
        if (sessann < 5)
        { this.det_sessann = 'H'}
        else if (sessann < 7)
        { this.det_sessann = 'E'}
        else
        { this.det_sessann = 'A'}
        this.det_sessann += "-" + moment(this.det_end).format('YY')
    },

},



methods: {

group_save:function() {

    var sql = "UPDATE MyMEQ_GROUP SET "
    sql += " group_CODE = '" + this.det_code
    sql += "', group_SESS = '" + this.det_sessann.substr(0,1)
    sql += "', group_ANN = '" + this.det_sessann.substr(2,2)
    sql += "', group_datSTART = '" +  moment(this.det_start).format('YYYY-MM-DD')
    sql += "',group_datEND = '" + moment(this.det_end).format('YYYY-MM-DD')
    sql += "', group_LANG = '" + this.det_lang
    sql += "', staff_ID_1 = " + this.chk_prof(this.det_prof1)
    sql += ", staff_ID_2 = " + this.chk_prof(this.det_prof2)
    sql += " WHERE group_ID = " + this.group_id 
    sql += ";"
     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
            this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true}); 
            this.is_changed = false 
    });

},

ponderation_show:function() {
// SHOW ADD STUDENT MODAL
    if (this.data_ponderation.length == 0) {this.ponderation_click_new()}
    document.querySelector('#myModalPonderation').classList.add('is-active');
},
ponderation_hide:function() {
// HIDE ADD STUDENT MODAL
    document.querySelector('#myModalPonderation').classList.remove('is-active');
},
ponderation_save_modal:function() {
// SAVE PONDERATION


var sql = ''
var self=this;
// this.data_ponderation.forEach(function(data){
for (var i = 0; i < this.data_ponderation.length; i++) {
    if (this.data_ponderation[i].ponderation_ID == 0) 
        { sql += " INSERT INTO MyMEQ_PROF_PONDERATION " 
        sql += " (group_ID ,ponderation_Desc ,ponderation_Percent ,ponderation_Max ,ponderation_Order ,ponderation_PUBLIC) VALUES ("
        sql += self.group_id + ",'" + this.data_ponderation[i].ponderation_Desc.replace(/'/g,"''") + "','" + this.data_ponderation[i].ponderation_Percent + "','" + this.data_ponderation[i].ponderation_Max + "'," + this.data_ponderation[i].ponderation_Order + "," + "0" + ");"
    } else {
        sql += "UPDATE MyMEQ_PROF_PONDERATION SET " 
        sql += " ponderation_ORDER =  " + this.data_ponderation[i].ponderation_Order
        sql +=  ",ponderation_DESC =  '" + this.data_ponderation[i].ponderation_Desc.replace( "'", "''") 
        sql  +=  "', ponderation_Percent =  '" + this.data_ponderation[i].ponderation_Percent
        sql  +=  "', ponderation_Max =  '" + this.data_ponderation[i].ponderation_Max
        sql  +=  "' WHERE ponderation_ID =  " + this.data_ponderation[i].ponderation_ID + ";"
    }
}  //});  END LOOP

console.log('----')
console.log(sql)


     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
            this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true}); 
            document.querySelector('#myModalPonderation').classList.remove('is-active');
    });




},


 

students_add_show:function() {
// SHOW ADD STUDENT MODAL

// CLEAR PREVIOUS
    this.arr_studs_add = []
    this.student_add = []
    this.search = ''


    document.querySelector('#myModalStudentAddGroup').classList.add('is-active');
},
students_add_hide:function() {
// HIDE ADD STUDENT MODAL
    document.querySelector('#myModalStudentAddGroup').classList.remove('is-active');
},
students_add_save:function() {
// SAVE SELECTED STUDENTS TO GROUP
    var sql = ''
    for (var i = 0; i < this.arr_studs_add.length; i++) { sql += "INSERT INTO MyMEQ_COURSESTUDENT (student_ID, group_ID) VALUES (" + this.arr_studs_add[i] + "," + this.group_id + ");"}
     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
            // this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true}); 
            this.get_students_enrolled(true)
    });
},

students_remove_show:function() {
// SHOW ADD STUDENT MODAL
    document.querySelector('#myModalStudentRemoveGroup').classList.add('is-active');
},
students_remove_hide:function() {
// HIDE ADD STUDENT MODAL
    document.querySelector('#myModalStudentRemoveGroup').classList.remove('is-active');
},
students_remove_save:function() {
// REMOVE SELECTED STUDENTS FROM GROUP
    var sql = ''
    for (var i = 0; i < this.arr_studs_remove.length; i++) { sql += "DELETE FROM MyMEQ_COURSESTUDENT WHERE student_ID = " + this.arr_studs_remove[i] + " AND group_ID = " + this.group_id + ";"}
     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
            // this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true}); 
            this.get_students_enrolled(true)
    });
},



check_inscrit:function(studID) {
// CHECK IF STUDENT ALREADY ENROLLED
  var indx = this.data_student.findIndex(x => x.student_ID == studID);
  if (indx > -1) {return true}
  else {return false}
},




// ----------------------------------





emit_click_remove:function(studentID) {
    this.arr_studs_remove.push(studentID)
    //this.is_changed = true;
},
emit_click_remove_undo:function(studentID) {
    //this.is_changed = true;
    const index = this.arr_studs_remove.indexOf(studentID);
    if (index > -1) {
    this.arr_studs_remove.splice(index, 1);
    }
},
emit_click_add:function(studentID) {
    this.arr_studs_add.push(studentID)
    //this.is_changed = true;
},
emit_click_add_undo:function(studentID) {
   // this.is_changed = true;
    const index = this.arr_studs_add.indexOf(studentID);
    if (index > -1) {
    this.arr_studs_add.splice(index, 1);
    }
},
 
get_students_enrolled:function (showNotify) {
// FOR AFTER EDIT

        // if (showNotify) {

// this.$snotify.confirm('Example body content', 'Example title', {
//   timeout: 5000,
//   showProgressBar: true,
//   closeOnClick: false,
//   pauseOnHover: true,
//   buttons: [
//     {text: 'Yes', action: () => console.log('Clicked: Yes'), bold: false},
//     {text: 'No', action: () => console.log('Clicked: No')},
//     {text: 'Later', action: (toast) => {console.log('Clicked: Later'); vm.$snotify.remove(toast.id); } },
//     {text: 'Close', action: (toast) => {console.log('Clicked: No'); vm.$snotify.remove(toast.id); }, bold: true},
//   ]
// });


    // this.$snotify.async('Called with promise', 'Error async', () => new Promise((resolve, reject) => {
    //   setTimeout(() => reject({
    //     title: 'Error!!!',
    //     body: 'We got an example error!',
    //     config: {
    //       closeOnClick: true
    //     }
    //   }), 2000);
    // }));


            // this.$snotify.success('Saved !!', {
            // timeout: 2000,
            // showProgressBar: true,
            // closeOnClick: false,
            // pauseOnHover: true,
            //   animation: {
            //     enter: 'bounceInDown',
            //     exit: 'bounceInDown',
            //     time: 1000
            //     }
            // });
        // }

this.isLoading = true;
    this.data_student = []
    var sql = ` SELECT MyMEQ_STUDENT.* FROM  MyMEQ_STUDENT INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID WHERE MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + ` ORDER BY student_lNAME `
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
            this.data_student = res.data
            this.isLoading = false;
            // REFRESH THE MENU ON MAIN COMP (GROUP) -- ????
            this.$emit('emitCourseUpdate', this.data_student.length)


            if (showNotify) {
                this.$snotify.success('Saved !!', {
                timeout: 2000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true
                });
            }

    })

},


get_ponderations:function() {
    this.data_ponderation = []
    var sql = 'SELECT * FROM MyMEQ_PROF_PONDERATION WHERE group_ID = ' + this.group_id 
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
        this.data_ponderation = res.data
        this.is_changed=false
        })
},

toggle_save_details_XX:function() {
this.$snotify.success('Saved !!', {
  timeout: 2000,
  showProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true
}); 
},

toggle_save_details:function() {

if (this.is_changed == false) {this.is_changed = true ; return }

var i; var sql = ''

var self=this;
this.data_ponderation.forEach(function(data){
    if (data.ponderation_ID == 0) 
        { sql += " INSERT INTO MyMEQ_PROF_PONDERATION " 
        sql += " (group_ID ,ponderation_Desc ,ponderation_Percent ,ponderation_Max ,ponderation_Order ,ponderation_PUBLIC) VALUES ("
        sql += self.group_id + ",'" + data.ponderation_Desc.replace(/'/g,"''") + "','" + data.ponderation_Percent + "','" + data.ponderation_Max + "'," + data.ponderation_Order + "," + "0" + ");"
    } else {
        sql += "UPDATE MyMEQ_PROF_PONDERATION SET " 
        sql += " ponderation_ORDER =  " + data.ponderation_Order
        sql +=  ",ponderation_DESC =  '" + data.ponderation_Desc.replace( "'", "''") 
        sql  +=  "', ponderation_Percent =  '" + data.ponderation_Percent
        sql  +=  "', ponderation_Max =  '" + data.ponderation_Max
        sql  +=  "' WHERE ponderation_ID =  " + data.ponderation_ID + ";"
    }
}); // END LOOP

console.log(sql)

    
// ONE BIG QUERY --- !
this.isLoading = true;

    sql += "UPDATE MyMEQ_GROUP SET "
    sql += " group_CODE = '" + this.det_code
    sql += "', group_SESS = '" + this.det_sessann.substr(0,1)
    sql += "', group_ANN = '" + this.det_sessann.substr(2,2)
    sql += "', group_datSTART = '" +  moment(this.det_start).format('YYYY-MM-DD')
    sql += "',group_datEND = '" + moment(this.det_end).format('YYYY-MM-DD')
    sql += "', group_LANG = '" + this.det_lang
    sql += "', staff_ID_1 = " + this.chk_prof(this.det_prof1)
    sql += ", staff_ID_2 = " + this.chk_prof(this.det_prof2)
    sql += " WHERE group_ID = " + this.group_id 
    sql += ";"

// ADD STUDENT TO THE COURSE
    for (i = 0; i < this.arr_studs_add.length; i++) { sql += "INSERT INTO MyMEQ_COURSESTUDENT (student_ID, group_ID) VALUES (" + this.arr_studs_add[i] + "," + this.group_id + ");"}
// REMOVE STUDENT FROM THE COURSE
    for (i = 0; i < this.arr_studs_remove.length; i++) { sql += "DELETE FROM MyMEQ_COURSESTUDENT WHERE student_ID = " + this.arr_studs_remove[i] + " AND group_ID = " + this.group_id + ";"}

     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
        this.is_changed=false
        this.arr_studs_add = []
        this.arr_studs_remove = []

      this.get_students_enrolled(true)
        
        this.isLoading = false;
        this.is_changed = false;
        
  

        
        }) 

},

group_delete_confirm() {

    this.$snotify.html(`<div class="snotifyToast__title"><b>Delete Course?</b></div>
  <div class="snotifyToast__body">`+ this.det_code +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'error',
        buttons: [
            {text: 'Ok', action: (toast) => this.group_delete(toast), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });

},

group_delete:function(toast) {
    
    var query = "DELETE FROM MyMEQ_COURSESTUDENT WHERE group_ID = " + this.group_id
    query += "; DELETE FROM MyMEQ_PROF_PONDERATION WHERE group_ID = " + this.group_id
    query += "; DELETE FROM MyMEQ_GROUP WHERE group_ID = " + this.group_id
     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + query)
    .then(res => { 
        this.$snotify.success('COMPLETE!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
        this.$snotify.remove(toast.id);

    });

},

student_course_remove:function(index, sID) {
    this.student_data[index].isEnrolled = false 
    this.is_changed = true
}, //END STUD REMOVE
student_course_remove_undo:function(index, sID) {
    this.student_data[index].isEnrolled = true 
    this.is_changed = true
}, //END STUD REMOVE
return_style_stud_current:function(isEnrolled) {
// STUDENT ENROLLED ALREADY IS CLICKED 
    if(!isEnrolled) {
        return 'has-background-danger has-text-white'
    } else {
        return 'has-background_white has-text-dark'
    }
},


student_course_add:function(index) {
    this.student_add[index].isEnrolled = true 
    this.is_changed = true
}, //END STUD REMOVE
student_course_add_undo:function(index) {
    this.student_add[index].isEnrolled = false 
    this.is_changed = true
}, //END STUD REMOVE

return_style_stud_new:function(isEnrolled) {
// NEW STUDENT IS CLICKED
    if(isEnrolled) {
        return 'has-background-success has-text-dark'
    } else {
        return 'has-background-white has-text-dark'
    }
},

students_search_clear:function() {
    this.search = ''
    this.student_add = []

},



students_search:function() {
 
    //this.arr_studs_add = [] // CLEAR ADD
    if (this.search == '') {return;}

        this.isLoading=true;

    var query =  `SELECT  TOP (100) MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE, COUNT(MyMEQ_COURSESTUDENT.group_ID) AS cnt, MAX(MyMEQ_GROUP.group_datEND) AS maxDt
    ,student_rueNUM + ' ' + student_Address + '   ' + student_apt + ',  ' + student_City AS ADDRESS,prog_TITRE_F,prog_TITRE_E, student_TelHome, student_TelOther, student_eMail ,  student_SecretCode, student_CreateDate
    FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID LEFT OUTER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID        
    WHERE  student_GRPCODE LIKE '` + this.search  + `%25' OR 
    student_lNAME LIKE '` + this.search  + `%25' OR 
    student_CodePerm LIKE '` + this.search  + `%25'  
    GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE,prog_TITRE_F,prog_TITRE_E,student_rueNUM,student_Address ,student_apt,  student_City, student_TelHome, student_TelOther, student_eMail,  student_SecretCode , student_CreateDate  
    ORDER BY student_lNAME,student_fNAME`;

        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.student_add = res.data
        this.isLoading=false;   })  
},
search_clear:function(){
    this.isLoading=true;
    this.student_add = ''
    this.arr_studs_add = [] // CLEAR ADD
    this.search = ''
    this.isLoading=false;
},

ponderation_click:function(index){
    this.show_pond=true;
    this.pond_index= index
    this.pond_id = this.data_ponderation[index].ponderation_ID
    this.pond_desc = this.data_ponderation[index].ponderation_Desc
    this.pond_order = this.data_ponderation[index].ponderation_Order
    this.pond_max = this.data_ponderation[index].ponderation_Max
    this.pond_percentage = this.data_ponderation[index].ponderation_Percent
},
ponderation_click_new:function(){

    // if (this.show_pond == true) { this.show_pond = false ; return }


    var obj = {};
    obj.ponderation_ID = 0
    obj.ponderation_Desc = ''
    obj.ponderation_Order = this.data_ponderation.length
    obj.ponderation_Max = 0
    obj.ponderation_Percent = 0
    this.data_ponderation.push(obj); 

    // this.show_pond=true;
    // this.pond_index= -1
    // this.pond_id = 0
    // this.pond_desc = ''
    // this.pond_max = ''
    // this.pond_order = this.data_ponderation.length + 1
    // this.pond_percentage = ''

},


ponderation_delete_check:function() {
    if (this.pond_id == 0) 
    {this.pond_desc = '';this.pond_percentage = '';this.pond_max = ''; }
    else { this.show_confirm_pond = true }
   
},
ponderation_delete_cancel:function() {
     this.show_confirm_pond = false 
},
ponderation_delete_delete:function() {

var sql = "DELETE FROM MyMEQ_PROF_PONDERATION WHERE ponderation_ID = " + this.pond_id
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => {
    // REMOVE FROM ARRAY
        this.data_ponderation.splice(this.pond_index,1)
        this.show_confirm_pond = false 
});

},

ponderation_save:function() {
// JUST PUSH TO ARAY FOR NOW

    if (this.pond_id == 0) {
        this.data_ponderation.push({ponderation_ID : 0, ponderation_Desc : this.pond_desc, ponderation_Max : this.pond_max ,ponderation_Percent : this.pond_percentage, ponderation_Order : this.pond_order   }) 
    } else { 
        this.data_ponderation[this.pond_index].ponderation_Desc = this.pond_desc
        this.data_ponderation[this.pond_index].ponderation_Order = this.pond_order
        this.data_ponderation[this.pond_index].ponderation_Max = this.pond_max
        this.data_ponderation[this.pond_index].ponderation_Percent = this.pond_percentage
    }// END IF 

    this.pond_index= -1
    this.pond_id = 0
    this.pond_desc = ''
    this.pond_max = ''
    this.pond_order = this.data_ponderation.length + 1
    this.pond_percentage = ''


},


ponderation_save_save:function() {

var query = ''
this.data_ponderation.forEach(function(data){
    if (data.pond_id == 0) 
        { query += " INSERT INTO MyMEQ_PROF_PONDERATION " 
        query += " (group_ID ,ponderation_Desc ,ponderation_Percent ,ponderation_Max ,ponderation_Order ,ponderation_PUBLIC) VALUES ("
        query += this.group_id + ",'" + data.ponderation_Desc.replace(/'/g,"''") + "','" + data.ponderation_Percent + "','" + data.ponderation_Max + "'," + data.ponderation_Order + "," + "0" + ");"
    } else {
        query += "UPDATE MyMEQ_PROF_PONDERATION SET " 
        query += " ponderation_ORDER =  " + data.ponderation_Order
        query +=  ",ponderation_DESC =  '" + data.ponderation_Desc.replace( "'", "''") 
        query  +=  "', ponderation_Percent =  '" + data.ponderation_Percent
        query  +=  "', ponderation_Max =  '" + data.ponderation_Max
        query  +=  "' WHERE ponderation_ID =  " + this.pond_id
    }
}); // END LOOP



},

ponderation_update:function() {

    var sql  = "UPDATE MyMEQ_PROF_PONDERATION SET " 
    sql  += " ponderation_ORDER =  " + '1'
    sql  +=  ",ponderation_DESC =  '" + this.pond_desc.replace( "'", "''") 
    sql  +=  "', ponderation_Percent =  '" + this.pond_percentage
    sql  +=  "', ponderation_Max =  '" + this.pond_max
    sql  +=  "' WHERE ponderation_ID =  " + this.pond_id
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { this.get_ponderations()
     this.show_pond=false;})

},
 

chkAdminMod:function(){
if (sessionStorage.getItem('user_level') != 'ADMIN') 
    {return 'disabledDiv' } else { return ''  }
},
chkAdminView:function(){
if (sessionStorage.getItem('user_level') == 'ADMIN') 
    {return true } else { return false  }
},
return_col_width_ponderation:function(){
if (sessionStorage.getItem('user_level') == 'ADMIN') 
    {return 'is-3' } else { return 'is-6'  }
},


// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},
chk_prof:function(val) {
    if (Number.isInteger(val))
    {return val} else {return null}
},

return_style_save:function(){
    if (this.is_changed)
    {return 'has-background-success has-text-white isLink'}
    else {return 'has-background-grey-dark has-text-warning isLink'}
},

pond_delete_confirm:function(index) {
    this.$snotify.confirm('Delete Ponderation : ' + this.data_ponderation[index].ponderation_Desc + '?' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.pond_delete_execute(toast,index)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]
    });
},

pond_delete_execute:function(toast,index) {
    this.$snotify.remove(toast.id)
    var sql = "DELETE FROM MyMEQ_PROF_PONDERATION WHERE ponderation_ID = " + this.data_ponderation[index].ponderation_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_ponderation.splice(index,1)
        this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    });
},



}, // END METHODS



} // END EXPORT
</script>




<style scoped>

.disabledDiv {
    pointer-events: none;
    opacity: 0.6;
}

.disabled {
  pointer-events: none;
}

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>